import { RFValue } from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  padding: 0 24px;
`;

export const Form = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const FormSurface = styled.View`
  padding: ${RFValue(12)}px;
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({ theme }) => theme.colors.border2};
  background-color: ${({ theme }) => theme.colors.background};
  shadow-color: #000;
  shadow-opacity: 0.06;
  shadow-radius: 8px;
  shadow-offset: 0px 4px;
  elevation: 3;
`;

export const UnitsList = styled.View`
  margin-top: ${RFValue(8)}px;
`;

export const Section = styled.View`
  margin-top: ${RFValue(12)}px;
`;

export const SectionTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(8)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.text_dark};
`;

export const ContentHeader = styled.View`
  margin: 0 24px;
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionCard = styled.View`
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({ theme }) => theme.colors.border2};
  padding: ${RFValue(8)}px ${RFValue(12)}px ${RFValue(12)}px;
  background-color: ${({ theme }) => theme.colors.background};
  shadow-color: #000;
  shadow-opacity: 0.06;
  shadow-radius: 8px;
  shadow-offset: 0px 4px;
  elevation: 3;
`;

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${RFValue(4)}px;
`;

export const SectionBadge = styled.View`
  padding: ${RFValue(4)}px ${RFValue(8)}px;
  background-color: ${({ theme }) => theme.colors.background_secondary};
  border-radius: ${RFValue(12)}px;
  
`;

export const SectionBadgeText = styled.Text`
  background-color: ${({ theme }) => theme.colors.background_secondary};
  color: ${({ theme }) => theme.colors.text_dark};
  font-size: ${RFValue(10)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
`;
